import Api from "../../utils/Api.jsx";
import LabeledInput from "../componentes/LabeledInput";
import Modal from "../componentes/Modal.jsx";
import React from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";

class ModalAlterarSenha extends React.Component {
  state = {
    senha_atual: "",
    senha_usuario: "",
    confirmar_senha: "",
  };

  async show() {
    this.modal.show();
    setTimeout(() => {
      if (this.inputSenha) {
        this.inputSenhaAtual.focus();
      }
    }, 500);
  }

  async confirmar() {
    const { senha_atual, senha_usuario, confirmar_senha } = this.state;

    if (!senha_atual || !senha_usuario || !confirmar_senha) {
      return toastr.error("Atenção", "Preencha todos os campos");
    }

    if (senha_usuario !== confirmar_senha) {
      return toastr.error(
        "Atenção",
        "Nova Senha e Confirmar Senha não coincidem"
      );
    }

    const ret = await Api.setAlterarSenha(
      this.props.usuario.id_pk,
      senha_usuario,
      senha_atual
    );

    if (!ret.status) {
      toastr.error("Erro", ret.erro);
      return;
    }

    if (ret.dados && ret.dados.erro) {
      return toastr.error("Atenção", ret.dados.erro);
    }

    this.hide();
    toastr.success("Sucesso!", "Senha alterada com sucesso");
  }

  hide() {
    this.modal.hide();
    this.setState({
      senha_atual: "",
      senha_usuario: "",
      confirmar_senha: "",
    });
  }

  render() {
    const botoes = [
      {
        icon: "fa-check",
        label: "Confirmar",
        className: "btn-green",
        onClick: this.confirmar.bind(this),
      },
      {
        icon: "fa-times",
        label: "Cancelar",
        className: "btn-danger",
        dismiss: true,
        onClick: () => this.hide(),
      },
    ];
    return (
      <Modal
        styleFadeModal="fadePreferencias"
        buttons={botoes}
        ref={(e) => (this.modal = e)}
        title="Alterar Senha"
        closeOnEsc
        confirmOnF2={() => this.confirmar()}
      >
        <LabeledInput
          styleLabel={{ fontSize: "14px" }}
          style={{ height: "30px" }}
          label="Senha Atual "
          value={this.state.senha_atual}
          type="password"
          uppercase={false}
          onChange={(e) => this.setState({ senha_atual: e.target.value })}
          onKeyEnter={() => this.inputSenha.focus()}
          inputRef={(e) => (this.inputSenhaAtual = e)}
        />
        <LabeledInput
          styleLabel={{ fontSize: "14px" }}
          style={{ height: "30px" }}
          label="Nova Senha: "
          value={this.state.senha_usuario}
          type="password"
          uppercase={false}
          onChange={(e) => this.setState({ senha_usuario: e.target.value })}
          onKeyEnter={() => this.inputSenhaConfirmar.focus()}
          inputRef={(e) => (this.inputSenha = e)}
        />
        <LabeledInput
          styleLabel={{ fontSize: "14px" }}
          style={{ height: "30px" }}
          label="Confirmar Nova Senha: "
          value={this.state.confirmar_senha}
          type="password"
          uppercase={false}
          onChange={(e) => this.setState({ confirmar_senha: e.target.value })}
          onKeyEnter={() => this.confirmar()}
          inputRef={(e) => (this.inputSenhaConfirmar = e)}
        />
      </Modal>
    );
  }
}

export default connect(
  (state) => ({
    usuario: state.usuario,
  }),
  (dispatch) => ({ dispatch }),
  null,
  { withRef: true }
)(ModalAlterarSenha);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/main/ModalAlterarSenha.jsx